import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import Load from '../Load/Load';
import * as Yup from "yup";
import { useFormik } from "formik";
import bgImage from '../../Images/back3.jpg'
import loginLogo from '../../Images/logo spoki.jpeg'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEye,
    faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";

import { login, sendOtp, verifyOtp, resetPassword, register } from "../../Web Apis/webApis"

const Login = () => {

    const [redirect, setRedirect] = useState(0)
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [timer, setTimer] = useState(60); // Initial 60 seconds

    // Start the timer when the component is mounted or Resend OTP is clicked
    useEffect(() => {
        if (redirect === 2) {
            if (timer > 0) {
                const interval = setInterval(() => {
                    setTimer((prev) => prev - 1);
                }, 1000);

                return () => clearInterval(interval); // Cleanup interval on unmount
            }
        }

    }, [redirect, timer]);

    // Listen for back button and redirect to /home
    useEffect(() => {
        const handlePopState = () => {
            navigate('/login'); // Redirect to /login when the back button is pressed
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate]);


    const handleForgetPassword = () => {
        setRedirect(1);
        return;
    }


    const initialValues = {
        email: "",
        password: "",
        otpEmail: "",
        otp: ['', '', '', ''],  // 4 OTP digits as an array
        newPassword: "",
        confirmPassword: "",
        name: "",
        registerEmail: "",
        registerPassword: "",
        confirmRegisterPassword: ""
    };

    const getValidationSchema = (redirect) => {

        switch (redirect) {

            case 0: // Sign In
                return Yup.object({
                    email: Yup.string()
                        .email("Invalid email address")
                        .matches(
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            "Enter valid email"
                        )
                        .required("Email id is required"),

                    password: Yup.string().required("Password is required"),
                })

            case 1: // Send Otp
                return Yup.object({
                    otpEmail: Yup.string()
                        .email("Invalid email address")
                        .matches(
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            "Enter valid email"
                        )
                        .required("Email id is required"),
                })

            case 2: // Verify Otp
                return Yup.object().shape({
                    otp: Yup.array()
                    .test(
                        "otp-filled",
                        "Please enter OTP",
                        (otp) => Array.isArray(otp) && otp.filter(Boolean).length === 4
                      )
                      .test(
                        "otp-numeric",
                        "OTP should contain only numbers",
                        (otp) =>
                          Array.isArray(otp) &&
                          otp.length === 4 &&
                          otp.every((digit) => /^\d$/.test(digit))
                      )
                })

            case 3: // Reset Password
                return Yup.object({
                    newPassword: Yup.string()
                        .matches(
                            /^(?=(.*[a-z]))(?=(.*[A-Z]))(?=(.*\d))(?=(.*[\W_])).{8,}$/,
                            "Password must be at least 8 characters, include an uppercase letter, a lowercase letter, a number, and a special character."
                        )
                        .required("Password is required"),

                    confirmPassword: Yup.string()
                        .oneOf([Yup.ref('newPassword')], "New password and confirm password should be match") // Ensures confirmPassword matches newPassword
                        .required("Confirm password is required")
                })

            case 4: // Register
                return Yup.object({
                    name: Yup.string()
                        .min(2, "Name must be at least 2 characters")
                        .max(100, "Name must be less than 100 characters")
                        .required("Name is required"),

                    registerEmail: Yup.string()
                        .email("Invalid email address")
                        .matches(
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            "Enter valid email"
                        )
                        .required("Email is required"),

                    registerPassword: Yup.string()
                        .matches(
                            /^(?=(.*[a-z]))(?=(.*[A-Z]))(?=(.*\d))(?=(.*[\W_])).{8,}$/,
                            "Password must be at least 8 characters, include an uppercase letter, a lowercase letter, a number, and a special character."
                        )
                        .required("Password is required"),

                    confirmRegisterPassword: Yup.string()
                        .oneOf([Yup.ref('registerPassword')], "Passwords must match")
                        .required("Confirm password is required")
                })

            default: return;
        }
    }

    const inputRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),

    ];

    const handleBackspace = (index, event) => {
        if (event.key === 'Backspace' && index > 0 && !event.target.value) {
            inputRefs[index - 1].current.focus(); // Move focus to the previous input field
        }
    };

    const handleDigitInput = (index, value) => {
        // Update Formik's OTP value
        const otp = [...formik.values.otp];
        otp[index] = value; // Update the specific digit in the OTP array
        formik.setFieldValue('otp', otp); // Set the OTP array in Formik

        // Move focus to the next input field
        if (value.length > 0 && index < inputRefs.length - 1) {
            if (inputRefs[index + 1]?.current) {
                inputRefs[index + 1].current.focus();
            }
        }
        // Move focus to the previous input field if the value is deleted
        else if (value.length === 0 && index > 0) {
            if (inputRefs[index - 1]?.current) {
                inputRefs[index - 1].current.focus();
            }
        }
    };


    const formik = useFormik({
        initialValues,
        validationSchema: getValidationSchema(redirect),

        onSubmit: async (values, { setSubmitting, resetForm }) => {
            // Join OTP digits to form the full OTP string
            const otp = values.otp.join('') || "";   // This joins the OTP array into a single string
            // Check redirect state and send appropriate actionType
            if (redirect === 0) {
                await handleSubmit(values, { setSubmitting, resetForm }, 'signIn')
            }
            else if (redirect === 1) {
                await handleSubmit(values, { setSubmitting, resetForm }, 'sendOtp')
            } else if (redirect === 2) {
                await handleSubmit({ ...values, otp }, { setSubmitting, resetForm }, 'verifyOtp');
            } else if (redirect === 3) {
                await handleSubmit(values, { setSubmitting, resetForm }, 'resetPassword')
            } else if (redirect === 4) {
                await handleSubmit(values, { setSubmitting, resetForm }, 'register')
            }
        }
    })

    const handleSubmit = async (values, { setSubmitting, resetForm }, actionType) => {
        let response;
        setLoading(true)
        setSubmitting(true)
        try {

            if (actionType === 'signIn') {
                response = await login({ values })
                console.log("response--->", response)
                if (response?.data?.success) {
                    localStorage.setItem("token", response?.data?.data?.tokens?.access?.token)
                    message.success(response?.data?.message)
                    setTimeout(() => {
                        window.location.href = "/home"
                    }, 500)
                    return;
                }

            }

            if (actionType === 'sendOtp') {

                response = await sendOtp({ values })

                if (response?.data?.success) {
                    message.success(response?.data?.message)
                    setRedirect(2)
                    return;
                }
            }

            if (actionType === 'verifyOtp') {
                response = await verifyOtp({ values })
                if (response?.data?.success) {
                    message.success(response?.data?.message)
                    formik.setFieldValue('otp', ['', '', '', '']);
                    setRedirect(3)
                    return;
                }
            }

            if (actionType === 'resetPassword') {
                response = await resetPassword({ values });
                if (response?.data?.success) {
                    message.success(response?.data?.message);
                    setRedirect(0);
                }
            }

            if (actionType === 'register') {
                response = await register({
                    name: values.name,
                    email: values.registerEmail,
                    password: values.registerPassword
                });
                if (response) {
                    message.success(response?.data?.message || "Registration successful! Please login now.");
                    // Switch to login form
                    setRedirect(0);
                    // Reset form to login initial values
                    formik.resetForm({
                        values: {
                            ...formik.initialValues,
                            email: values.registerEmail // Pre-fill email for convenience
                        }
                    });
                    // Clear password visibility states
                    setShowNewPassword(false);
                    setShowConfirmPassword(false);
                }
            }

        } catch (error) {
            console.log("Error during form submission", error.message)
            if (error?.response?.status === 500) {
                message.error("Server not responding")
            } else {
                message.error(error?.response?.data?.message)
            }
        } finally {
            setSubmitting(false)
            setLoading(false)
        }
    }

    const handleResendOtp = async () => {
        try {
            setLoading(true)

            const response = await sendOtp(formik)
            if (response?.data?.success) {
                message.success(response?.data?.message)
                formik.setFieldValue('otp', ['', '', '', '']);
                setTimer(60);
            }

        } catch (error) {
            console.log("Resend Otp Error ", error.message)
            message.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }





    return (

        <div className="relative min-h-screen">
            {/* Loader */}
            {loading && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <Load />
                </div>
            )}

            <div className="flex min-h-screen">

                {/* Left Side: Background Image */}
                <div
                    className="w-1/2 bg-cover bg-center"
                    style={{
                        backgroundImage: `url(${bgImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                    }}
                >
                </div>

                {redirect === 0 && (

                    <div className="w-1/2 flex items-center justify-center bg-teal-100">
                        <div className="bg-white bg-opacity-90 p-10 rounded-xl shadow-2xl w-full max-w-md">
                            <h2 className="text-3xl font-extrabold mb-5 text-center text-gray-800">
                                Login
                            </h2>

                            <div className="h-36 flex justify-center mt-4">
                                <img className=" w-100" src={loginLogo} alt="logo" />
                            </div>
                            <h3 className="text-2xl font-extrabold mb-8 text-center text-gray-800 mt-2">
                                Spoki Ai Referral Admin
                            </h3>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="mb-6">
                                    <label className="block mb-3 text-gray-800 font-semibold" htmlFor="email">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className={`border-2 p-3 w-full rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-500 transition ${formik.errors.email ? 'border-red-500' : 'border-gray-300'
                                            }`}
                                    />
                                    {formik.touched.email && formik.errors.email && (
                                        <p className="text-red-600 text-sm mt-2">{formik.errors.email}</p>
                                    )}
                                </div>

                                <div className="mb-6">
                                    <label className="block mb-3 text-gray-800 font-semibold" htmlFor="password">
                                        Password
                                    </label>
                                    <div className="relative">
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            id="password"
                                            name="password"
                                            placeholder="Enter your password"
                                            value={formik.values.password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={`border-2 p-3 w-full rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-500 transition ${formik.errors.password ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        />

                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="absolute inset-y-0 right-0 flex items-center "
                                        >
                                            <FontAwesomeIcon
                                                icon={showPassword ? faEye : faEyeSlash}
                                                className="text-gray-500 mr-2"
                                            />
                                        </button>
                                    </div>
                                    {formik.touched.password && formik.errors.password && (
                                        <p className="text-red-600 text-sm mt-2">{formik.errors.password}</p>
                                    )}
                                </div>

                                <div className=" text-blue-600 w-40 mt-1 mb-4 " >
                                    <a variant="small" color="blue-gray" >
                                        {/* <button type='button' className="font-medium hover:text-orange-900 underline" onClick={handleForgetPassword} style={{ cursor: "pointer" }}> Forgot Password</button> */}
                                    </a>
                                </div>

                                <button
                                    type="submit"
                                    className="bg-gradient-to-r mt- from-blue-500 to-blue-600 text-white font-semibold py-3 w-full rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200"
                                >
                                    {formik.isSubmitting ? 'Loging in ...' : 'Login'}
                                </button>

                                {/* <div className="text-center mt-6">
                                    <p className="text-gray-600">
                                        Don't have an account?{" "}
                                        <button
                                            type="button"
                                            onClick={() => setRedirect(4)}
                                            className="text-blue-600 hover:text-blue-800 font-medium underline focus:outline-none"
                                        >
                                            Sign Up
                                        </button>
                                    </p>
                                </div> */}
                            </form>
                        </div>
                    </div>
                )}

                {redirect === 4 && (

                    <div className="w-1/2 flex items-center justify-center bg-teal-100">
                        <div className="bg-white bg-opacity-90 p-10 rounded-xl shadow-2xl w-full max-w-md">
                            <h2 className="text-3xl font-extrabold mb-5 text-center text-gray-800">
                                Sign Up
                            </h2>

                            <div className="h-36 flex justify-center mt-4">
                                <img className="w-100" src={loginLogo} alt="logo" />
                            </div>
                            <h3 className="text-2xl font-extrabold mb-8 text-center text-gray-800 mt-2">
                                Spoki Ai Referral Admin
                            </h3>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="mb-6">
                                    <label className="block mb-3 text-gray-800 font-semibold" htmlFor="name">
                                        Full Name
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Enter your full name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className={`border-2 p-3 w-full rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-500 transition ${formik.errors.name ? 'border-red-500' : 'border-gray-300'
                                            }`}
                                    />
                                    {formik.touched.name && formik.errors.name && (
                                        <p className="text-red-600 text-sm mt-2">{formik.errors.name}</p>
                                    )}
                                </div>

                                <div className="mb-6">
                                    <label className="block mb-3 text-gray-800 font-semibold" htmlFor="registerEmail">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        id="registerEmail"
                                        name="registerEmail"
                                        placeholder="Enter your email"
                                        value={formik.values.registerEmail}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className={`border-2 p-3 w-full rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-500 transition ${formik.errors.registerEmail ? 'border-red-500' : 'border-gray-300'
                                            }`}
                                    />
                                    {formik.touched.registerEmail && formik.errors.registerEmail && (
                                        <p className="text-red-600 text-sm mt-2">{formik.errors.registerEmail}</p>
                                    )}
                                </div>

                                <div className="mb-6">
                                    <label className="block mb-3 text-gray-800 font-semibold" htmlFor="registerPassword">
                                        Password
                                    </label>
                                    <div className="relative">
                                        <input
                                            type={showNewPassword ? 'text' : 'password'}
                                            id="registerPassword"
                                            name="registerPassword"
                                            placeholder="Create a password"
                                            value={formik.values.registerPassword}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={`border-2 p-3 w-full rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-500 transition ${formik.errors.registerPassword ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                            className="absolute inset-y-0 right-0 flex items-center"
                                        >
                                            <FontAwesomeIcon
                                                icon={showNewPassword ? faEye : faEyeSlash}
                                                className="text-gray-500 mr-2"
                                            />
                                        </button>
                                    </div>
                                    {formik.touched.registerPassword && formik.errors.registerPassword && (
                                        <p className="text-red-600 text-sm mt-2">{formik.errors.registerPassword}</p>
                                    )}
                                </div>

                                <div className="mb-6">
                                    <label className="block mb-3 text-gray-800 font-semibold" htmlFor="confirmRegisterPassword">
                                        Confirm Password
                                    </label>
                                    <div className="relative">
                                        <input
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            id="confirmRegisterPassword"
                                            name="confirmRegisterPassword"
                                            placeholder="Confirm your password"
                                            value={formik.values.confirmRegisterPassword}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={`border-2 p-3 w-full rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-500 transition ${formik.errors.confirmRegisterPassword ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            className="absolute inset-y-0 right-0 flex items-center"
                                        >
                                            <FontAwesomeIcon
                                                icon={showConfirmPassword ? faEye : faEyeSlash}
                                                className="text-gray-500 mr-2"
                                            />
                                        </button>
                                    </div>
                                    {formik.touched.confirmRegisterPassword && formik.errors.confirmRegisterPassword && (
                                        <p className="text-red-600 text-sm mt-2">{formik.errors.confirmRegisterPassword}</p>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    className="bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold py-3 w-full rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-200"
                                >
                                    {formik.isSubmitting ? 'Creating Account...' : 'Sign Up'}
                                </button>

                                <div className="text-center mt-6">
                                    <p className="text-gray-600">
                                        Already have an account?{" "}
                                        <button
                                            type="button"
                                            onClick={() => setRedirect(0)}
                                            className="text-blue-600 hover:text-blue-800 font-medium underline focus:outline-none"
                                        >
                                            Login
                                        </button>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {redirect === 1 && (

                    <div className="w-1/2 flex items-center justify-center bg-teal-100">
                        <div className="bg-white bg-opacity-90 p-10 rounded-xl shadow-2xl w-full max-w-md">
                            <h2 className="text-3xl font-extrabold mb-8 text-center text-gray-800">
                                Send OTP
                            </h2>
                            <div className="h-36 flex justify-center mt-4">
                                <img className="w-100" src={loginLogo} alt="logo" />
                            </div>
                            <h3 className="text-2xl font-extrabold mb-8 text-center text-gray-800 mt-2">
                                Spoki Ai Referral Admin
                            </h3>
                            <h3 className='font-bold mt-10 mb-5 text-center text-blue-300'>Enter your registered email</h3>

                            <form onSubmit={formik.handleSubmit}>
                                <div className="mb-6">
                                    <label className="block mb-3 text-gray-800 font-semibold" htmlFor="otpEmail">
                                        Email
                                    </label>
                                    <input
                                        type="otpEmail"
                                        id="otpEmail"
                                        name="otpEmail"
                                        placeholder="Enter your email"
                                        value={formik.values.otpEmail}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className={`border-2 p-3 w-full rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-500 transition ${formik.errors.otpEmail ? 'border-red-500' : 'border-gray-300'
                                            }`}
                                    />
                                    {formik.touched.otpEmail && formik.errors.otpEmail && (
                                        <p className="text-red-600 text-sm mt-2">{formik.errors.otpEmail}</p>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    className="bg-gradient-to-r mt- from-blue-500 to-blue-600 text-white font-semibold py-3 w-full rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200"
                                >
                                    {formik.isSubmitting ? 'Sending ...' : 'Send OTP'}
                                </button>
                            </form>
                        </div>
                    </div>
                )}


                {redirect === 2 && (

                    <div className="w-1/2 flex items-center justify-center bg-teal-100">
                        <div className="bg-white bg-opacity-90 p-10 rounded-xl shadow-2xl w-full max-w-md">
                            <h2 className="text-3xl font-extrabold mb-8 text-center text-gray-800">
                                Verify OTP
                            </h2>
                            <div className="h-36 flex justify-center mt-4">
                                <img className="w-100" src={loginLogo} alt="logo" />
                            </div>
                            <h3 className="text-2xl font-extrabold mb-8 text-center text-gray-800 mt-2">
                                Spoki Ai Referral Admin
                            </h3>

                            <h3 className='font-bold mt-10 mb-5 text-center text-blue-300'>Enter your 4 digit otp to verify your email</h3>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="flex justify-center gap-8">

                                    <div className="space-x-2 mt-4 mb-4">
                                        {formik.values.otp.map((digit, index) => (
                                            <input
                                                key={index}
                                                type="text"
                                                maxLength="1"
                                                value={digit}
                                                onChange={(e) => handleDigitInput(index, e.target.value)}
                                                onKeyDown={(e) => handleBackspace(index, e)}
                                                ref={inputRefs[index]}
                                                className="w-10 h-10 text-center border border-black rounded-lg"
                                            />
                                        ))}

                                        {formik.errors.otp && (
                                            <p className="text-red-600 text-sm mt-2 text-center">{formik.errors.otp}</p>
                                        )}

                                    </div>
                                </div>

                                <div className=" text-blue-600 w-40 mb-2 " >
                                    <a variant="small" color="blue-gray" >
                                        <button type='button' className="font-medium hover:text-orange-900 underline"
                                            onClick={handleResendOtp}
                                            style={{ cursor: timer > 0 ? "not-allowed" : "pointer" }}
                                            disabled={timer > 0}
                                        >
                                            {timer > 0 ? `Resend in : ${timer} s` : "Resend OTP"}
                                        </button>
                                    </a>
                                </div>

                                <button
                                    type="submit"
                                    className="bg-gradient-to-r mt- from-blue-500 to-blue-600 text-white font-semibold py-3 w-full rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200"
                                >
                                    {formik.isSubmitting ? 'Verifying ...' : 'Verify OTP'}
                                </button>
                            </form>
                        </div>
                    </div>
                )}


                {redirect === 3 && (

                    <div className="w-1/2 flex items-center justify-center bg-teal-100">
                        <div className="bg-white bg-opacity-90 p-10 rounded-xl shadow-2xl w-full max-w-md">
                            <h2 className="text-3xl font-extrabold mb-8 text-center text-gray-800">
                                Reset Password
                            </h2>
                            <div className="h-36 flex justify-center mt-4">
                                <img className="w-100" src={loginLogo} alt="logo" />
                            </div>
                            <h3 className="text-2xl font-extrabold mb-8 text-center text-gray-800 mt-2">
                                Spoki Ai Referral Admin
                            </h3>
                            <h3 className='font-bold mt-10 mb-5 text-center text-blue-300'>Reset your password</h3>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="mb-6">
                                    <label className="block mb-3 text-gray-800 font-semibold" htmlFor="newPassword">
                                        New Password
                                    </label>
                                    <div className="relative">
                                        <input
                                            type={showNewPassword ? 'text' : 'password'}
                                            id="newPassword"
                                            name="newPassword"
                                            placeholder="Enter your new password"
                                            value={formik.values.newPassword}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={`border-2 p-3 w-full rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-500 transition ${formik.errors.newPassword ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                            className="absolute inset-y-0 right-0 flex items-center "
                                        >
                                            <FontAwesomeIcon
                                                icon={showNewPassword ? faEye : faEyeSlash}
                                                className="text-gray-500 mr-2"
                                            />
                                        </button>
                                    </div>
                                    {formik.touched.newPassword && formik.errors.newPassword && (
                                        <p className="text-red-600 text-sm mt-2">{formik.errors.newPassword}</p>
                                    )}
                                </div>

                                <div className="mb-6">
                                    <label className="block mb-3 text-gray-800 font-semibold" htmlFor="confirmPassword">
                                        Confirm Password
                                    </label>
                                    <div className="relative">
                                        <input
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            placeholder="Confirm your password"
                                            value={formik.values.confirmPassword}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={`border-2 p-3 w-full rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-500 transition ${formik.errors.confirmPassword ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        />

                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            className="absolute inset-y-0 right-0 flex items-center "
                                        >
                                            <FontAwesomeIcon
                                                icon={showConfirmPassword ? faEye : faEyeSlash}
                                                className="text-gray-500 mr-2"
                                            />
                                        </button>
                                    </div>
                                    {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                                        <p className="text-red-600 text-sm mt-2">{formik.errors.confirmPassword}</p>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    className="bg-gradient-to-r mt- from-blue-500 to-blue-600 text-white font-semibold py-3 w-full rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200"
                                >
                                    {formik.isSubmitting ? 'Reseting ...' : 'Reset Password'}
                                </button>
                            </form>
                        </div>
                    </div>
                )}


            </div>
        </div>

    )
}

export default Login